import React from 'react';
import { Box, FormControl, Grid, MenuItem, Select, Typography, Divider } from '@mui/material';
import { KeyboardArrowDown } from '@material-ui/icons';

const SelectField = ({
    label,
    value,
    onChange,
    options = [],
    placeholder = 'Select',
    showCount = true,
    disabled=false,
    ...props
}) => {
    return (
        <FormControl fullWidth size="small" {...props}
            disabled={disabled}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    border: '1px solid #E0E0E0',
                    borderRadius: '4px',
                    p: 1,
                    width: '260px',
                    cursor: 'pointer',
                    backgroundColor: 'white',
                    '&:hover': {
                        borderColor: '#00A67E'
                    },
                    opacity: disabled ? '0.3':''
                }}
            >
                <Typography sx={{
                    fontWeight: 600,
                    fontSize: '14px',
                }}>
                    {label}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                    <Typography
                        primary
                        sx={{
                            fontSize: '14px',
                            fontWeight: 500,
                            color: '#00A67E',
                            overflow: 'hidden',
                            whiteSpace: "pre",
                            maxWidth: '12   0px',
                        }}
                    >
                        {value ? options.find((option) => option.value === value)?.label : "Select"}
                    </Typography>

                    <KeyboardArrowDown style={{ color: '#00A67E' }} />
                </Box>
            </Box>
            <Select
                value={value}
                onChange={onChange}
                displayEmpty
                MenuProps={{
                    PaperProps: {
                        sx: {
                            mt: 1,
                            boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.08)',
                            borderRadius: '8px',
                            '& .MuiMenuItem-root': {
                                py: 1.5,
                                px: 2,
                                '&:hover': {
                                    backgroundColor: '#F5F5F5'
                                }
                            }
                        }
                    }
                }}
                sx={{
                    position: 'absolute',
                    opacity: 0,
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0
                }}
            >
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value} sx={{ borderBottom: "1px solid #EAEAEA" }}>
                        <Box sx={{ display: 'flex', gap: 8, justifyContent: "space-between", alignItems: "end", py: 0.5, width: "100%" }}>
                            <Grid 
                            sx={{ maxWidth: '260px', overflow: 'hidden' }}
                            >
                                <Typography sx={{  fontSize: '14px', color: '#1A1A1A' }}>
                                    {option.label}
                                </Typography>
                                {option.description && (
                                    <Typography
                                        title={option.description}
                                        sx={{
                                            fontSize: '12px',
                                            color: '#757575',
                                            fontWeight: 400,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {option.description}
                                    </Typography>
                                )}
                            </Grid>
                            <Typography
                                sx={{
                                    fontSize: '12px',
                                    color: '#757575',
                                    fontWeight: 400
                                }}
                            >
                                {option.count > 0 ? option.count + " items" : ""}
                            </Typography>
                        </Box>

                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default SelectField;